var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkToggleEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 0.25V0.289062C9.44531 0.289062 9.71875 0.289062 9.95312 0.289062C10.2266 0.328125 10.4609 0.523438 10.5 0.796875C10.5781 1.07031 10.4609 1.34375 10.2266 1.46094C8.11719 2.63281 6.71094 4.89844 6.71094 7.4375C6.71094 11.2656 9.79688 14.3125 13.5859 14.3125C13.9766 14.3125 14.3672 14.3125 14.7578 14.2344C15.0312 14.1953 15.3047 14.3125 15.4219 14.5469C15.5391 14.8203 15.5 15.0938 15.3047 15.2891C13.7422 16.8125 11.5938 17.75 9.21094 17.75C4.40625 17.75 0.5 13.8438 0.5 9C0.5 4.19531 4.40625 0.25 9.21094 0.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkToggleEnabled);
export default __webpack_public_path__ + "static/media/dark_toggle_enabled.920b349901620f1c7213eb3387baea5b.svg";
export { ForwardRef as ReactComponent };